import {Venue} from '../models/Venue';
import {TimeUtils} from './time-utils';

export const isVenueOpen = (venue: Venue) => {
	return (
		venue &&
		venue.isServiceActivated &&
		venue.openingHours &&
		venue.openingHours?.length > 0 &&
		TimeUtils.doesHoursMatchNow(venue.openingHours)
	);
};
